import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import { cropName } from '../../common/utils/cropNames.mjs';

const formatMaturity = (seconds) => {
  const totalMinutes = Math.max(0, Math.round(Number(seconds || 0) / 60));
  if (totalMinutes >= 60 && totalMinutes % 60 === 0) return `${totalMinutes / 60} 小时`;
  return `${totalMinutes} 分钟`;
};

export default class SeedPickerModal extends Modal {
  className() {
    return 'YingtaoSeedPickerModal Modal--medium';
  }

  title() {
    return '选择种子';
  }

  content() {
    const catalog = this.attrs.catalog || {};
    const entries = Object.entries(catalog);

    return (
      <div className="Modal-body">
        <div className="YingtaoSeedPicker" role="list">
          {entries.map(([cropKey, crop]) => (
            <Button
              key={cropKey}
              className="Button YingtaoSeedPicker-option"
              role="listitem"
              onclick={() => {
                this.attrs.onChoose(cropKey);
                this.hide();
              }}
            >
              <strong>{cropName(cropKey)}</strong>
              <span>{formatMaturity(crop.mature_seconds)} · 预计收获 {crop.base_yield ?? '-'} 个</span>
              <span>种子 {crop.seed_price ?? '-'} 金币 · 收购单价 {crop.sell_price ?? '-'} 金币/个</span>
            </Button>
          ))}
        </div>
      </div>
    );
  }
}
